/* eslint-disable react/jsx-pascal-case */
/* eslint-disable no-plusplus */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-nested-ternary */
import {
  Accordion,
  Affix,
  Badge,
  Button,
  Card,
  Center,
  Divider,
  Group,
  Loader,
  Table as MantineTable,
  Paper,
  SimpleGrid,
  Space,
  Stack,
  Transition,
} from '@mantine/core';
import { useWindowScroll } from '@mantine/hooks';
import { showNotification } from '@mantine/notifications';
import { IconArrowNarrowUp, IconBriefcase, IconShare } from '@tabler/icons-react';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { ReactNode, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import calcularPreco from '../../../../business/proposals/estimate';
import PageHeader from '../../../../components/core/PageHeader/PageHeader';
import PageSection from '../../../../components/core/PageSection/PageSection';
import PageViewProperty from '../../../../components/core/PageViewProperty/PageViewProperty';
import ProfileCardLink from '../../../../components/core/ProfileCardLink/ProfileCardLink';
import { ProposalStatusType, UnitOfMeasureType } from '../../../../models/core/cache.type';
import { EntityType } from '../../../../models/core/entities.type';
import {
  ProposalResidueType,
  ProposalServiceType,
  ProposalType,
} from '../../../../models/core/proposals.type';
import entitiesService from '../../../../services/core/entities.service';
import proposalsService from '../../../../services/core/proposals.service';
import { montarRecorrenciaString } from '../../../../utils/business.utils';
import cacheUtils from '../../../../utils/cache.utils';
import { Feature } from '../../../../utils/constants.utils';
import { formatCurrency, formatDateToString } from '../../../../utils/formatter.utils';
import { isNullOrEmpty, newGuid } from '../../../../utils/helper.utils';

type Result = {
  loading: boolean;
  referenceData: {
    unitOfMeasures: UnitOfMeasureType[];
    proposalStatusTypes: ProposalStatusType[];
  } | null;
  data: { proposal: ProposalType; client: EntityType } | null;
};

function ProposalView() {
  const navigate = useNavigate();
  const { idProposta } = useParams();
  const queryParams = new URLSearchParams(useLocation().search);
  const excelFormat = queryParams.get('excel') === 'true';
  const [scroll, scrollTo] = useWindowScroll();
  const refContent = useRef<any>();

  const [result, setResult] = useState<Result>({
    loading: true,
    referenceData: null,
    data: null,
  });

  const formatOptionalCurrency = (value: unknown) => {
    return isNullOrEmpty(value) ? '-' : formatCurrency(Number(value));
  };

  const buildReferenceText = (
    quantidade: unknown,
    quantidadeUnidadeMedida: unknown,
    frequenciaUnidadeMedida?: unknown
  ) => {
    if (isNullOrEmpty(quantidade)) {
      return '-';
    }

    return frequenciaUnidadeMedida
      ? `${quantidade} ${quantidadeUnidadeMedida} / ${frequenciaUnidadeMedida}`
      : `${quantidade} ${quantidadeUnidadeMedida}`;
  };

  const buildSupplierPrice = (quotation: any, receita = false) => {
    if (isNullOrEmpty(quotation?.preco)) {
      return <>-</>;
    }
    return (
      <span style={{ color: receita ? 'green' : 'red' }}>{`${formatOptionalCurrency(
        quotation?.preco
      )} | ${buildReferenceText(
        quotation?.quantidade,
        quotation?.quantidadeUnidadeMedida,
        quotation?.frequenciaUnidadeMedida
      )}`}</span>
    );
  };

  const calculateCustomerPrice = (quotation: any, compra: boolean, receita = false) => {
    if (isNullOrEmpty(quotation?.precificacao?.preco)) {
      return null;
    }

    return calcularPreco(
      quotation.preco,
      quotation.precificacao?.preco,
      quotation.precificacao?.imposto || 0,
      compra,
      receita
    );
  };

  const buildCustomerPricingText = (quotation: any, compra: boolean, receita = false) => {
    const price = calculateCustomerPrice(quotation, compra, receita);
    if (!price) {
      return null;
    }

    const finalPrice = receita ? price.preco : price.novoPrecoComMargem;
    return `${formatCurrency(finalPrice)} | ${buildReferenceText(
      quotation?.precificacao?.quantidade,
      quotation?.precificacao?.quantidadeUnidadeMedida,
      quotation?.precificacao?.frequenciaUnidadeMedida
    )}`;
  };

  const buildPricingItem = (receita: boolean, quotation: any, compra: boolean) => {
    const price = calculateCustomerPrice(quotation, compra, receita);
    if (!price) {
      return <>-</>;
    }

    const marginColor =
      price.novaMargemFinalPorcentagem > 0
        ? 'green'
        : price.novaMargemFinalPorcentagem < 0
        ? 'red'
        : 'orange';

    const finalPrice = receita ? price.preco : price.novoPrecoComMargem;
    const finalMargin = (price.novaMargemFinalPorcentagem || 0).toFixed(2);
    const referenceText = buildReferenceText(
      quotation?.precificacao?.quantidade,
      quotation?.precificacao?.quantidadeUnidadeMedida,
      quotation?.precificacao?.frequenciaUnidadeMedida
    );

    return (
      <>
        <div
          style={{
            color: marginColor,
          }}
        >{`${formatCurrency(finalPrice)} | ${referenceText} (${finalMargin}%)`}</div>
        <div style={{ fontSize: 'small' }}>{`Preço: ${formatCurrency(
          Number(quotation?.precificacao?.preco || 0)
        )}`}</div>
        <div style={{ fontSize: 'small' }}>{`Imposto: ${quotation?.precificacao?.imposto || 0}%`}</div>
      </>
    );
  };

  const getRecurrenceText = (recorrencia: any) => {
    const data = montarRecorrenciaString(recorrencia);
    return data ? `${data.str1}${data.str2 ? ` (${data.str2})` : ''}` : '-';
  };

  const getSupplierName = (quotation: any) =>
    quotation?.fornecedorNomeFantasia || quotation?.fornecedorRazaoSocial || quotation?.fornecedorNome || '-';

  const getCustomerPriceValue = (quotation: any, compra: boolean, receita = false) => {
    const price = calculateCustomerPrice(quotation, compra, receita);
    if (!price) {
      return '-';
    }
    return formatCurrency(receita ? price.preco : price.novoPrecoComMargem);
  };

  const getCustomerReferenceText = (quotation: any) =>
    buildReferenceText(
      quotation?.precificacao?.quantidade,
      quotation?.precificacao?.quantidadeUnidadeMedida,
      quotation?.precificacao?.frequenciaUnidadeMedida
    );

  const getServiceSupplierReferenceText = (quotation: any) =>
    buildReferenceText(
      quotation?.quantidade,
      quotation?.frequenciaUnidadeMedida1,
      quotation?.frequenciaUnidadeMedida2
    );

  const cloneTemplateRow = (
    worksheet: ExcelJS.Worksheet,
    templateRowNumber: number,
    targetRowNumber: number,
    totalColumns: number
  ) => {
    if (targetRowNumber === templateRowNumber) {
      return;
    }

    const templateRow = worksheet.getRow(templateRowNumber);
    const targetRow = worksheet.getRow(targetRowNumber);
    targetRow.height = templateRow.height;

    for (let column = 1; column <= totalColumns; column++) {
      const templateCell = templateRow.getCell(column);
      const targetCell = targetRow.getCell(column);
      targetCell.style = JSON.parse(JSON.stringify(templateCell.style || {}));
      if (templateCell.numFmt) {
        targetCell.numFmt = templateCell.numFmt;
      }
    }
  };

  const writeRowsToTemplate = (
    worksheet: ExcelJS.Worksheet,
    rows: (string | number | null)[][],
    startRow: number,
    startColumn: number,
    totalColumns: number
  ) => {
    const lastExistingRow = worksheet.rowCount;
    for (let rowNumber = startRow; rowNumber <= lastExistingRow; rowNumber++) {
      const row = worksheet.getRow(rowNumber);
      for (let column = startColumn; column <= totalColumns; column++) {
        row.getCell(column).value = null;
      }
    }

    rows.forEach((rowData, index) => {
      const currentRowNumber = startRow + index;
      cloneTemplateRow(worksheet, startRow, currentRowNumber, totalColumns);
      const row = worksheet.getRow(currentRowNumber);
      rowData.forEach((cellValue, cellIndex) => {
        row.getCell(startColumn + cellIndex).value = cellValue;
      });
      row.commit();
    });
  };

  const populateAndDownload = async (proposal: ProposalType, client: EntityType) => {
    const templatePath = `${process.env.PUBLIC_URL}/templates/proposta.xlsx?v=${Date.now()}`;

    const response = await fetch(templatePath);
    const buffer = await response.arrayBuffer();

    const workbook = new ExcelJS.Workbook();
    await workbook.xlsx.load(buffer);
    workbook.creator = 'Performa Manager';
    workbook.lastModifiedBy = 'Performa Manager';
    workbook.created = new Date();
    workbook.modified = new Date();

    const residuesWorksheet = workbook.worksheets[0];
    const servicesWorksheet = workbook.worksheets[1];

    const clientName = client.nomeFantasia || client.razaoSocial || client.nome || '-';
    const clientDocument = client.cnpj || client.cpf || '-';

    residuesWorksheet.getCell('F3').value = clientName;
    residuesWorksheet.getCell('F4').value = clientDocument;
    residuesWorksheet.getCell('F5').value = `Proposta #${proposal.idProposta}`;
    servicesWorksheet.getCell('F3').value = clientName;
    servicesWorksheet.getCell('F4').value = clientDocument;
    servicesWorksheet.getCell('F5').value = `Proposta #${proposal.idProposta}`;

    const residueRows: any[][] = [];
    for (const residue of proposal.residuos) {
      const recurrenceText = getRecurrenceText(residue.recorrencia);
      const estimateText = buildReferenceText(
        residue.estimativa,
        residue.estimativaUnidadeMedida1,
        residue.estimativaUnidadeMedida2
      );
      const minimumText = buildReferenceText(
        residue.minimoAceitavel,
        residue.minimoAceitavelUnidadeMedida1,
        residue.minimoAceitavelUnidadeMedida2
      );

      for (const plan of residue.planos) {
        for (const quotation of plan.cotacoes || []) {
          for (const item of quotation.acondicionamentos || []) {
            const planItem = plan.acondicionamentos.find(
              (x) => x.idPropostaResiduoPlanoAcondicionamento === item.idPropostaResiduoPlanoAcondicionamento
            );
            residueRows.push([
              `${residue.idPropostaResiduo}.${planItem?.idPropostaResiduoPlanoAcondicionamento || '-'}`,
              residue.residuoCliente,
              plan.codigoPlanoTipo,
              item.idPropostaResiduoPlanoCotacao,
              'Acondicionamento',
              item.residuoAcondicionamento || planItem?.residuoAcondicionamento || '-',
              plan.primario ? 'Sim' : 'Não',
              quotation.primario ? 'Sim' : 'Não',
              residue.compra ? 'Sim' : 'Não',
              residue.cobrarTolerancia ? 'Sim' : 'Não',
              recurrenceText,
              estimateText,
              minimumText,
              planItem?.gerenciar ? 'Sim' : 'Não',
              planItem?.compartilhado ? 'Sim' : 'Não',
              `${planItem?.compartilhado ? '% de ' : ''}${buildReferenceText(
                planItem?.quantidade,
                planItem?.quantidadeUnidadeMedida
              )}`,
              getSupplierName(item),
              formatOptionalCurrency(item.preco),
              planItem?.compartilhado
                ? '%'
                : buildReferenceText(
                    item.quantidade,
                    item.quantidadeUnidadeMedida,
                    item.frequenciaUnidadeMedida
                  ),
              getCustomerPriceValue(item, residue.compra),
              getCustomerReferenceText(item),
              `${item.precificacao?.imposto || 0}%`,
              '-',
              item.observacao || planItem?.observacao || '-',
            ]);
          }

          for (const item of quotation.equipamentos || []) {
            const planItem = plan.equipamentos.find(
              (x) => x.idPropostaResiduoPlanoEquipamento === item.idPropostaResiduoPlanoEquipamento
            );
            residueRows.push([
              `${residue.idPropostaResiduo}.${planItem?.idPropostaResiduoPlanoEquipamento || '-'}`,
              residue.residuoCliente,
              plan.codigoPlanoTipo,
              item.idPropostaResiduoPlanoCotacao,
              'Equipamento',
              item.residuoEquipamento || planItem?.residuoEquipamento || '-',
              plan.primario ? 'Sim' : 'Não',
              quotation.primario ? 'Sim' : 'Não',
              residue.compra ? 'Sim' : 'Não',
              residue.cobrarTolerancia ? 'Sim' : 'Não',
              recurrenceText,
              estimateText,
              minimumText,
              '-',
              '-',
              buildReferenceText(planItem?.quantidade, planItem?.quantidadeUnidadeMedida),
              getSupplierName(item),
              formatOptionalCurrency(item.preco),
              buildReferenceText(item.quantidade, item.quantidadeUnidadeMedida, item.frequenciaUnidadeMedida),
              getCustomerPriceValue(item, residue.compra),
              getCustomerReferenceText(item),
              `${item.precificacao?.imposto || 0}%`,
              '-',
              item.observacao || planItem?.observacao || '-',
            ]);
          }

          if (quotation.veiculo) {
            const item = quotation.veiculo;
            residueRows.push([
              `${residue.idPropostaResiduo}.${plan.veiculo?.idPropostaResiduoPlanoVeiculo || '-'}`,
              residue.residuoCliente,
              plan.codigoPlanoTipo,
              quotation.idPropostaResiduoPlanoCotacao,
              'Veículo',
              item.residuoVeiculo || plan.veiculo?.residuoVeiculo || '-',
              plan.primario ? 'Sim' : 'Não',
              quotation.primario ? 'Sim' : 'Não',
              residue.compra ? 'Sim' : 'Não',
              residue.cobrarTolerancia ? 'Sim' : 'Não',
              recurrenceText,
              estimateText,
              minimumText,
              '-',
              plan.veiculo?.compartilhado ? 'Sim' : 'Não',
              buildReferenceText(plan.veiculo?.quantidade, plan.veiculo?.quantidadeUnidadeMedida),
              getSupplierName(item),
              formatOptionalCurrency(item.preco),
              buildReferenceText(item.quantidade, item.quantidadeUnidadeMedida, item.frequenciaUnidadeMedida),
              getCustomerPriceValue(item, residue.compra),
              getCustomerReferenceText(item),
              `${item.precificacao?.imposto || 0}%`,
              '-',
              item.observacao || plan.veiculo?.observacao || '-',
            ]);
          }

          if (quotation.tratamento) {
            const item = quotation.tratamento;
            residueRows.push([
              `${residue.idPropostaResiduo}.${plan.tratamento?.idPropostaResiduoPlanoTratamento || '-'}`,
              residue.residuoCliente,
              plan.codigoPlanoTipo,
              quotation.idPropostaResiduoPlanoCotacao,
              'Tratamento',
              item.residuoTratamento || plan.tratamento?.residuoTratamento || '-',
              plan.primario ? 'Sim' : 'Não',
              quotation.primario ? 'Sim' : 'Não',
              residue.compra ? 'Sim' : 'Não',
              residue.cobrarTolerancia ? 'Sim' : 'Não',
              recurrenceText,
              estimateText,
              minimumText,
              '-',
              '-',
              '-',
              getSupplierName(item),
              formatOptionalCurrency(item.preco),
              buildReferenceText(item.quantidade, item.quantidadeUnidadeMedida),
              getCustomerPriceValue(item, residue.compra),
              getCustomerReferenceText(item),
              `${item.precificacao?.imposto || 0}%`,
              '-',
              item.observacao || plan.tratamento?.observacao || '-',
            ]);
          }

          if (quotation.destinoFinal) {
            const item = quotation.destinoFinal;
            residueRows.push([
              `${residue.idPropostaResiduo}.${plan.destinoFinal?.idPropostaResiduoPlanoDestinoFinal || '-'}`,
              residue.residuoCliente,
              plan.codigoPlanoTipo,
              quotation.idPropostaResiduoPlanoCotacao,
              'Destino Final',
              item.residuoDestinoFinal || plan.destinoFinal?.residuoDestinoFinal || '-',
              plan.primario ? 'Sim' : 'Não',
              quotation.primario ? 'Sim' : 'Não',
              residue.compra ? 'Sim' : 'Não',
              residue.cobrarTolerancia ? 'Sim' : 'Não',
              recurrenceText,
              estimateText,
              minimumText,
              '-',
              '-',
              '-',
              getSupplierName(item),
              formatOptionalCurrency(item.preco),
              buildReferenceText(item.quantidade, item.quantidadeUnidadeMedida),
              getCustomerPriceValue(item, residue.compra, item.receita),
              getCustomerReferenceText(item),
              `${item.precificacao?.imposto || 0}%`,
              item.receita ? 'Sim' : 'Não',
              item.observacao || plan.destinoFinal?.observacao || '-',
            ]);
          }
        }
      }
    }

    writeRowsToTemplate(residuesWorksheet, residueRows, 9, 2, 25);

    const serviceRows: any[][] = [];
    for (const service of proposal.servicos) {
      const recurrenceText = getRecurrenceText(service.recorrencia);

      for (const quotation of service.cotacoes || []) {
        serviceRows.push([
          service.idPropostaServico,
          service.servico,
          service.residuoAcondicionamento || service.residuoEquipamento || 'Fornecedor',
          quotation.idPropostaServicoCotacao,
          quotation.primario ? 'Sim' : 'Não',
          recurrenceText,
          service.jornada || '-',
          service.turno || '-',
          service.idResiduoAcondicionamento ? (service.gerenciar ? 'Sim' : 'Não') : '-',
          service.idResiduoAcondicionamento ? (service.compartilhado ? 'Sim' : 'Não') : '-',
          buildReferenceText(service.quantidade, quotation.precificacao?.quantidadeUnidadeMedida),
          service.idResiduoAcondicionamento || service.idResiduoEquipamento
            ? '-'
            : buildReferenceText(
                service.frequencia,
                service.frequenciaUnidadeMedida1,
                service.frequenciaUnidadeMedida2
              ),
          getSupplierName(quotation),
          formatOptionalCurrency(quotation.preco),
          getServiceSupplierReferenceText(quotation),
          getCustomerPriceValue(quotation, false),
          getCustomerReferenceText(quotation),
          `${quotation.precificacao?.imposto || 0}%`,
          quotation.observacao || service.observacao || '-',
        ]);
      }
    }

    writeRowsToTemplate(servicesWorksheet, serviceRows, 9, 2, 20);

    const excelBuffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, `proposta_${proposal.idProposta}.xlsx`);
  };

  useEffect(() => {
    const fetchData = async () => {
      let { referenceData, data } = result;
      try {
        if (result.referenceData === null) {
          referenceData = {
            unitOfMeasures: await cacheUtils.listUnityOfMeasures(),
            proposalStatusTypes: await cacheUtils.listProposalStatuses(),
          };
        }
        const proposal = await proposalsService.select({ idProposta: Number(idProposta) });
        const client = await entitiesService.select({ idEntidade: Number(proposal.idCliente) });
        data = { proposal, client };

        if (excelFormat) {
          await populateAndDownload(proposal, client);
        } else {
          setTimeout(() => window.print(), 1500);
        }
      } catch (error: any) {
        showNotification({
          title: 'Proposta - Imprimir',
          message: error?.isBusinessException ? error.description : `Não foi possível carregar a proposta.`,
          color: 'red',
        });
        navigate(`/${error?.statusCode || '500'}`, {
          replace: true,
        });
      } finally {
        setResult({ loading: false, referenceData, data });
      }
    };

    if (result.data === null) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const buildSectionHeader = (description: string) => {
    return (
      <PageHeader
        feature={Feature.Home.Proposal}
        title={`Proposta #${result.data!.proposal.idProposta}`}
        description={description}
        buttons={[]}
        padding={0}
      />
    );
  };

  const buildGeneral = () => {
    const { proposal } = result.data!;

    return (
      <div style={{ pageBreakAfter: 'always' }}>
        {buildSectionHeader('Informações gerais.')}
        <Paper shadow="xs" p="md" withBorder>
          <PageSection size="lg" color={Feature.Home.Proposal.color} label="Geral" text="" />
          <Space h="xs" />

          <MantineTable withTableBorder withColumnBorders striped>
            <MantineTable.Tbody>
              <MantineTable.Tr>
                <MantineTable.Td>Proposta de Origem</MantineTable.Td>
                <MantineTable.Td>{proposal.idPropostaPai || '-'}</MantineTable.Td>
                <MantineTable.Td>Empresa Responsável</MantineTable.Td>
                <MantineTable.Td>
                  <Badge variant="outline">{proposal.empresa}</Badge>
                </MantineTable.Td>
              </MantineTable.Tr>
              <MantineTable.Tr>
                <MantineTable.Td>Status</MantineTable.Td>
                <MantineTable.Td>
                  <Badge variant="outline">{proposal.propostaStatus}</Badge>
                </MantineTable.Td>
                <MantineTable.Td>Gerenciador</MantineTable.Td>
                <MantineTable.Td>
                  {!proposal.idGerenciador
                    ? '-'
                    : `${
                        proposal.gerenciadorNomeFantasia ||
                        proposal.gerenciadorRazaoSocial ||
                        proposal.gerenciadorNome
                      } (${proposal.gerenciadorCNPJ || proposal.gerenciadorCPF})`}
                </MantineTable.Td>
              </MantineTable.Tr>
              <MantineTable.Tr>
                <MantineTable.Td>Data Inicial</MantineTable.Td>
                <MantineTable.Td>{formatDateToString(proposal.dataInicial)}</MantineTable.Td>
                <MantineTable.Td>Contato</MantineTable.Td>
                <MantineTable.Td>{`${proposal.nome} (${
                  proposal.telefone || proposal.celular || proposal.email || proposal.setor || '-'
                })`}</MantineTable.Td>
              </MantineTable.Tr>
              <MantineTable.Tr>
                <MantineTable.Td>Data Final</MantineTable.Td>
                <MantineTable.Td>{formatDateToString(proposal.dataFinal)}</MantineTable.Td>
                <MantineTable.Td>Fechamento</MantineTable.Td>
                <MantineTable.Td>
                  <Badge variant="outline">{proposal.fechamento}</Badge>
                </MantineTable.Td>
              </MantineTable.Tr>
              <MantineTable.Tr>
                <MantineTable.Td>Validade</MantineTable.Td>
                <MantineTable.Td>
                  <Badge variant="outline">{formatDateToString(proposal.validade)}</Badge>
                </MantineTable.Td>
                <MantineTable.Td>Lembrete da Validade</MantineTable.Td>
                <MantineTable.Td>
                  {proposal.validadeLembreteDias ? `${proposal.validadeLembreteDias} dia(s)` : '-'}
                </MantineTable.Td>
              </MantineTable.Tr>
              <MantineTable.Tr>
                <MantineTable.Td>Documentação</MantineTable.Td>
                <MantineTable.Td>{proposal.documentacaoCliente || '-'}</MantineTable.Td>
                <MantineTable.Td>Lembrete da Documentação</MantineTable.Td>
                <MantineTable.Td>
                  {proposal.documentacaoClienteRecorrenciaDias
                    ? `${proposal.documentacaoClienteRecorrenciaDias} dia(s)`
                    : '-'}
                </MantineTable.Td>
              </MantineTable.Tr>
              <MantineTable.Tr>
                <MantineTable.Td>Observação</MantineTable.Td>
                <MantineTable.Td colSpan={3}>{proposal.observacao || '-'}</MantineTable.Td>
              </MantineTable.Tr>
            </MantineTable.Tbody>
          </MantineTable>
        </Paper>
      </div>
    );
  };

  const buildClient = () => {
    const { client } = result.data!;

    const buildClientGeneral = () => {
      // const address = client.enderecos.find((x) => x.codigoEnderecoTipo === 'PR');

      return (
        <MantineTable withTableBorder withColumnBorders striped>
          <MantineTable.Tbody>
            <MantineTable.Tr>
              <MantineTable.Td>Razão Social / Nome</MantineTable.Td>
              <MantineTable.Td>{client.razaoSocial || client.nome}</MantineTable.Td>
              <MantineTable.Td>CNPJ / CPF</MantineTable.Td>
              <MantineTable.Td>
                <Badge variant="outline">{client.cnpj || client.cpf}</Badge>
              </MantineTable.Td>
            </MantineTable.Tr>
            <MantineTable.Tr>
              <MantineTable.Td>Nome Fantasia</MantineTable.Td>
              <MantineTable.Td>{client.nomeFantasia || '-'}</MantineTable.Td>
              <MantineTable.Td>Inscrição Estadual</MantineTable.Td>
              <MantineTable.Td>{client.incricaoEstadual || '-'}</MantineTable.Td>
            </MantineTable.Tr>
            <MantineTable.Tr>
              <MantineTable.Td>Encontro de Contas?</MantineTable.Td>
              <MantineTable.Td>
                <Badge variant="outline">{client.aceitaEncontroContas ? 'Sim' : 'Não'}</Badge>
              </MantineTable.Td>
              <MantineTable.Td>Web Site</MantineTable.Td>
              <MantineTable.Td>{client.webSite || '-'}</MantineTable.Td>
            </MantineTable.Tr>
            <MantineTable.Tr>
              <MantineTable.Td>Requisitos</MantineTable.Td>
              <MantineTable.Td colSpan={3}>{client.requisitos || '-'}</MantineTable.Td>
            </MantineTable.Tr>
            {/* <MantineTable.Tr>
            <MantineTable.Td>Endereço Principal</MantineTable.Td>
            <MantineTable.Td>
              {!address
                ? '-'
                : `${address?.logradouro}, ${address.numero}${
                    address.complemento ? ` - ${address.complemento}` : ''
                  }`}
            </MantineTable.Td>
            <MantineTable.Td>Cidade / UF</MantineTable.Td>
            <MantineTable.Td>{!address ? '-' : `${address.cidade} / ${address.codigoEstado}`}</MantineTable.Td>
          </MantineTable.Tr>
          <MantineTable.Tr>
            <MantineTable.Td>Bairro</MantineTable.Td>
            <MantineTable.Td>{!address ? '-' : address?.bairro}</MantineTable.Td>
            <MantineTable.Td>CEP</MantineTable.Td>
            <MantineTable.Td>{!address ? '-' : address?.cep}</MantineTable.Td>
          </MantineTable.Tr> */}
          </MantineTable.Tbody>
        </MantineTable>
      );
    };

    const buildPaymentMethod = () => {
      const nodes: ReactNode[] = [];

      for (const item of client.formasPagamento) {
        nodes.push(
          <MantineTable.Tr>
            <MantineTable.Td>{item.formaPagamento}</MantineTable.Td>
            <MantineTable.Td>
              {!item.prazoPagamentoDias ? '-' : `${item.prazoPagamentoDias} dia(s)`}
            </MantineTable.Td>
            <MantineTable.Td>{item.recebimento ? 'Recebimento' : 'Pagamento'}</MantineTable.Td>
            <MantineTable.Td>{item.cnpj || item.cpf}</MantineTable.Td>
            <MantineTable.Td>{item.nome}</MantineTable.Td>
            <MantineTable.Td>
              {item.codigoFormaPagamento === 'PX' && item.recebimento ? (
                `Chave PIX: ${item.chavePix}`
              ) : item.codigoFormaPagamento === 'TB' && item.recebimento ? (
                <div>
                  <div>Banco: {item.banco}</div>
                  <div>
                    Agência: {item.agencia} | Conta corrente: {item.contaCorrente}
                    {`${!item.digitoVerificador ? '' : `-${item.digitoVerificador}`}`}
                  </div>
                </div>
              ) : (
                '-'
              )}
            </MantineTable.Td>
          </MantineTable.Tr>
        );
      }

      return (
        <MantineTable withTableBorder withColumnBorders striped>
          <MantineTable.Thead>
            <MantineTable.Tr>
              <MantineTable.Th>Forma</MantineTable.Th>
              <MantineTable.Th>Prazo</MantineTable.Th>
              <MantineTable.Th>Tipo</MantineTable.Th>
              <MantineTable.Th>CNPJ / CPF</MantineTable.Th>
              <MantineTable.Th>Beneficiário</MantineTable.Th>
              <MantineTable.Th>Dados do Pagamento</MantineTable.Th>
            </MantineTable.Tr>
          </MantineTable.Thead>
          <MantineTable.Tbody>{nodes}</MantineTable.Tbody>
        </MantineTable>
      );
    };

    const buildContact = () => {
      const nodes: ReactNode[] = [];

      for (const item of client.contatos) {
        nodes.push(
          <MantineTable.Tr>
            <MantineTable.Td>{item.nome}</MantineTable.Td>
            <MantineTable.Td>{item.setor || '-'}</MantineTable.Td>
            <MantineTable.Td>{item.email || '-'}</MantineTable.Td>
            <MantineTable.Td>{item.telefone || '-'}</MantineTable.Td>
            <MantineTable.Td>{item.telefoneRamal || '-'}</MantineTable.Td>
            <MantineTable.Td>{item.celular || '-'}</MantineTable.Td>
          </MantineTable.Tr>
        );
      }

      return (
        <MantineTable withTableBorder withColumnBorders striped>
          <MantineTable.Thead>
            <MantineTable.Tr>
              <MantineTable.Th>Nome</MantineTable.Th>
              <MantineTable.Th>Setor</MantineTable.Th>
              <MantineTable.Th>E-mail</MantineTable.Th>
              <MantineTable.Th>Telefone</MantineTable.Th>
              <MantineTable.Th>Ramal</MantineTable.Th>
              <MantineTable.Th>Celular</MantineTable.Th>
            </MantineTable.Tr>
          </MantineTable.Thead>
          <MantineTable.Tbody>{nodes}</MantineTable.Tbody>
        </MantineTable>
      );
    };

    const buildAddress = () => {
      const nodes: ReactNode[] = [];

      for (const item of client.enderecos) {
        nodes.push(
          <MantineTable.Tr>
            <MantineTable.Td>{item.enderecoTipo}</MantineTable.Td>
            <MantineTable.Td>{`${item?.logradouro}, ${item.numero}${
              item.complemento ? ` - ${item.complemento}` : ''
            }`}</MantineTable.Td>
            <MantineTable.Td>{`${item.cidade} / ${item.codigoEstado}`}</MantineTable.Td>
            <MantineTable.Td>{item.bairro}</MantineTable.Td>
            <MantineTable.Td>{item.cep}</MantineTable.Td>
            <MantineTable.Td>
              {item.contatos.map((x) => {
                return (
                  <div>
                    {x.nome} ({x.telefone || x.celular || x.email || x.setor || '-'})
                  </div>
                );
              }) || '-'}
            </MantineTable.Td>
          </MantineTable.Tr>
        );
      }

      return (
        <MantineTable withTableBorder withColumnBorders striped>
          <MantineTable.Thead>
            <MantineTable.Tr>
              <MantineTable.Th>Tipo</MantineTable.Th>
              <MantineTable.Th>Endereço</MantineTable.Th>
              <MantineTable.Th>Cidade / UF</MantineTable.Th>
              <MantineTable.Th>Bairro</MantineTable.Th>
              <MantineTable.Th>CEP</MantineTable.Th>
              <MantineTable.Th>Contato(s)</MantineTable.Th>
            </MantineTable.Tr>
          </MantineTable.Thead>
          <MantineTable.Tbody>{nodes}</MantineTable.Tbody>
        </MantineTable>
      );
    };

    return (
      <div style={{ pageBreakAfter: 'always' }}>
        {buildSectionHeader('Informações do cliente.')}
        <Paper shadow="xs" p="md" withBorder>
          <PageSection size="lg" color={Feature.Home.Proposal.color} label="Cliente" text="" />
          <Space h="xs" />

          {buildClientGeneral()}
          <Space h="xs" />
          <Divider my="sm" variant="dashed" />

          <PageSection size="lg" color={Feature.Home.Proposal.color} label="Endereços" text="" />
          <Space h="xs" />
          {buildAddress()}
          <Space h="xs" />
          <Divider my="sm" variant="dashed" />

          <PageSection size="lg" color={Feature.Home.Proposal.color} label="Formas de Pagamento" text="" />
          <Space h="xs" />
          {buildPaymentMethod()}
          <Space h="xs" />
          <Divider my="sm" variant="dashed" />

          <PageSection size="lg" color={Feature.Home.Proposal.color} label="Contatos" text="" />
          <Space h="xs" />
          {buildContact()}
        </Paper>
      </div>
    );
  };

  const buildResidues = (): ReactNode[] => {
    const { proposal } = result.data!;

    const residueNodes: ReactNode[] = [];

    const buildResidueClient = (residuo: ProposalResidueType) => {
      const cliente = {
        cnpj: residuo.clienteCNPJ,
        razaoSocial: residuo.clienteRazaoSocial,
        nomeFantasia: residuo.clienteNomeFantasia,
        cpf: residuo.clienteCPF,
        nome: residuo.clienteNome,
      };
      const endereco = residuo;

      return (
        <div>
          <PageSection size="lg" color={Feature.Home.Proposal.color} label="Cliente e Local" text="" />
          <Space h="xs" />
          <MantineTable withTableBorder withColumnBorders striped>
            <MantineTable.Tbody>
              <MantineTable.Tr>
                <MantineTable.Td>Nome Fantasia / Razão Social / Nome</MantineTable.Td>
                <MantineTable.Td>
                  {cliente.nomeFantasia || cliente.razaoSocial || cliente.nome}
                </MantineTable.Td>
                <MantineTable.Td>CNPJ / CPF</MantineTable.Td>
                <MantineTable.Td>
                  <Badge variant="outline">{cliente.cnpj || cliente.cpf}</Badge>
                </MantineTable.Td>
              </MantineTable.Tr>
              <MantineTable.Tr>
                <MantineTable.Td>Endereço</MantineTable.Td>
                <MantineTable.Td>
                  {`${endereco?.logradouro}, ${endereco.numero}${
                    endereco.complemento ? ` - ${endereco.complemento}` : ''
                  }`}
                </MantineTable.Td>
                <MantineTable.Td>Cidade / UF</MantineTable.Td>
                <MantineTable.Td>{`${endereco.cidade} / ${endereco.codigoEstado}`}</MantineTable.Td>
              </MantineTable.Tr>
              <MantineTable.Tr>
                <MantineTable.Td>Bairro</MantineTable.Td>
                <MantineTable.Td>{endereco?.bairro}</MantineTable.Td>
                <MantineTable.Td>CEP</MantineTable.Td>
                <MantineTable.Td>{endereco?.cep}</MantineTable.Td>
              </MantineTable.Tr>
            </MantineTable.Tbody>
          </MantineTable>
        </div>
      );
    };

    const buildResidueDocuments = (residuo: ProposalResidueType) => {
      return (
        <div>
          <PageSection size="lg" color={Feature.Home.Proposal.color} label="Documentos" text="" />
          <Space h="xs" />
          {/* <Group>
            {residuo.documento.notaFiscal && <Badge variant="outline">Nota Fiscal</Badge>}
            {residuo.documento.xml && <Badge variant="outline">XML</Badge>}
            {residuo.documento.mtr && <Badge variant="outline">MTR</Badge>}
            {residuo.documento.sga && <Badge variant="outline">SGA</Badge>}
            {residuo.documento.romaneioColeta && <Badge variant="outline">Romaneio de coleta</Badge>}
            {residuo.documento.pesoOrigem && <Badge variant="outline">Peso Origem</Badge>}
            {residuo.documento.pesoDestino && <Badge variant="outline">Peso Destino</Badge>}
          </Group> */}
          <SimpleGrid cols={7}>
            <PageViewProperty
              label="Nota Fiscal"
              text={residuo.documento.notaFiscal ? 'Sim' : 'Não'}
              size="sm"
            />
            <PageViewProperty label="XML" text={residuo.documento.xml ? 'Sim' : 'Não'} size="sm" />
            <PageViewProperty label="MTR" text={residuo.documento.mtr ? 'Sim' : 'Não'} size="sm" />
            <PageViewProperty label="SGA" text={residuo.documento.sga ? 'Sim' : 'Não'} size="sm" />
            <PageViewProperty
              label="Romaneio de coleta"
              text={residuo.documento.romaneioColeta ? 'Sim' : 'Não'}
              size="sm"
            />
            <PageViewProperty
              label="Peso Origem"
              text={residuo.documento.pesoOrigem ? 'Sim' : 'Não'}
              size="sm"
            />
            <PageViewProperty
              label="Peso Destino"
              text={residuo.documento.pesoDestino ? 'Sim' : 'Não'}
              size="sm"
            />
          </SimpleGrid>
        </div>
      );
    };

    const buildPlan = (residuo: ProposalResidueType) => {
      const tableNodes: ReactNode[] = [];
      const quotationNodes: ReactNode[] = [];

      for (const plano of residuo.planos.filter((x) => x.primario)) {
        for (const cotacao of plano.cotacoes.filter((x) => x.primario)) {
          for (const x of cotacao.acondicionamentos) {
            const planoX = plano.acondicionamentos.find(
              (y) => y.idPropostaResiduoPlanoAcondicionamento === x.idPropostaResiduoPlanoAcondicionamento
            )!;
            const customerText = buildCustomerPricingText(x, residuo.compra);
            quotationNodes.push(
              <MantineTable.Tr key={`ra_${x.idPropostaResiduoPlanoCotacaoAcondicionamento}`}>
                <MantineTable.Td>
                  <Feature.Reference.Packaging.icon size={16} />
                  {planoX.gerenciar ? <IconBriefcase size={16} /> : <></>}
                  {planoX.compartilhado ? <IconShare size={16} /> : <></>}
                </MantineTable.Td>
                <MantineTable.Td>{x.residuoAcondicionamento}</MantineTable.Td>
                <MantineTable.Td>
                  {planoX.compartilhado ? '%' : `${planoX.quantidade} ${planoX.quantidadeUnidadeMedida}`}
                </MantineTable.Td>
                <MantineTable.Td>
                  {x.fornecedorNomeFantasia || x.fornecedorRazaoSocial || x.fornecedorNome}
                </MantineTable.Td>
                <MantineTable.Td>-</MantineTable.Td>
                <MantineTable.Td>{buildSupplierPrice(x)}</MantineTable.Td>
                <MantineTable.Td>
                  {customerText ? buildPricingItem(false, x, residuo.compra) : '-'}
                </MantineTable.Td>
              </MantineTable.Tr>
            );
          }

          for (const x of cotacao.equipamentos) {
            const planoX = plano.equipamentos.find(
              (y) => y.idPropostaResiduoPlanoEquipamento === x.idPropostaResiduoPlanoEquipamento
            )!;
            const customerText = buildCustomerPricingText(x, residuo.compra);
            quotationNodes.push(
              <MantineTable.Tr key={`re_${x.idPropostaResiduoPlanoCotacaoEquipamento}`}>
                <MantineTable.Td>
                  <Feature.Reference.Equipment.icon size={16} />
                </MantineTable.Td>
                <MantineTable.Td>{x.residuoEquipamento}</MantineTable.Td>
                <MantineTable.Td>
                  {planoX.quantidade} {planoX.quantidadeUnidadeMedida}
                </MantineTable.Td>
                <MantineTable.Td>
                  {x.fornecedorNomeFantasia || x.fornecedorRazaoSocial || x.fornecedorNome}
                </MantineTable.Td>
                <MantineTable.Td>-</MantineTable.Td>
                <MantineTable.Td>{buildSupplierPrice(x)}</MantineTable.Td>
                <MantineTable.Td>
                  {customerText ? buildPricingItem(false, x, residuo.compra) : '-'}
                </MantineTable.Td>
              </MantineTable.Tr>
            );
          }

          if (cotacao.veiculo) {
            const x = cotacao.veiculo;
            const planoX = plano.veiculo!;
            const customerText = buildCustomerPricingText(x, residuo.compra);
            quotationNodes.push(
              <MantineTable.Tr key={`rv_${x.idPropostaResiduoPlanoCotacaoVeiculo}`}>
                <MantineTable.Td>
                  <Feature.Reference.Vehicle.icon size={16} />
                </MantineTable.Td>
                <MantineTable.Td>{x.residuoVeiculo}</MantineTable.Td>
                <MantineTable.Td>
                  {planoX.quantidade} {planoX.quantidadeUnidadeMedida}
                </MantineTable.Td>
                <MantineTable.Td>
                  {x.fornecedorNomeFantasia || x.fornecedorRazaoSocial || x.fornecedorNome}
                </MantineTable.Td>
                <MantineTable.Td>-</MantineTable.Td>
                <MantineTable.Td>{buildSupplierPrice(x)}</MantineTable.Td>
                <MantineTable.Td>
                  {customerText ? buildPricingItem(false, x, residuo.compra) : '-'}
                </MantineTable.Td>
              </MantineTable.Tr>
            );
          }

          if (cotacao.tratamento) {
            const x = cotacao.tratamento;
            const customerText = buildCustomerPricingText(x, residuo.compra);

            quotationNodes.push(
              <MantineTable.Tr key={`rt_${x.idPropostaResiduoPlanoCotacaoTratamento}`}>
                <MantineTable.Td>
                  <Feature.Reference.Treatment.icon size={16} />
                </MantineTable.Td>
                <MantineTable.Td>{x.residuoTratamento}</MantineTable.Td>
                <MantineTable.Td>-</MantineTable.Td>
                <MantineTable.Td>
                  {x.fornecedorNomeFantasia || x.fornecedorRazaoSocial || x.fornecedorNome}
                </MantineTable.Td>
                <MantineTable.Td>
                  <div>{`${x.logradouro}, ${x.numero}${x.complemento ? ` - ${x.complemento}` : ''}`}</div>
                  <div>{`${x.bairro}, ${x.cidade} / ${x.codigoEstado} (${x.cep})`}</div>
                </MantineTable.Td>
                <MantineTable.Td>{buildSupplierPrice(x)}</MantineTable.Td>
                <MantineTable.Td>
                  {customerText ? buildPricingItem(false, x, residuo.compra) : '-'}
                </MantineTable.Td>
              </MantineTable.Tr>
            );
          }

          if (cotacao.destinoFinal) {
            const x = cotacao.destinoFinal;
            const customerText = buildCustomerPricingText(x, residuo.compra, x.receita!);

            quotationNodes.push(
              <MantineTable.Tr key={`rdf_${x.idPropostaResiduoPlanoCotacaoDestinoFinal}`}>
                <MantineTable.Td>
                  <Feature.Reference.Destination.icon size={16} />
                </MantineTable.Td>
                <MantineTable.Td>{x.residuoDestinoFinal}</MantineTable.Td>
                <MantineTable.Td>-</MantineTable.Td>
                <MantineTable.Td>
                  {x.fornecedorNomeFantasia || x.fornecedorRazaoSocial || x.fornecedorNome}
                </MantineTable.Td>
                <MantineTable.Td>
                  <div>{`${x.logradouro}, ${x.numero}${x.complemento ? ` - ${x.complemento}` : ''}`}</div>
                  <div>{`${x.bairro}, ${x.cidade} / ${x.codigoEstado} (${x.cep})`}</div>
                </MantineTable.Td>
                <MantineTable.Td>{buildSupplierPrice(x, x.receita!)}</MantineTable.Td>
                <MantineTable.Td>
                  {customerText ? buildPricingItem(x.receita!, x, residuo.compra) : '-'}
                </MantineTable.Td>
              </MantineTable.Tr>
            );
          }
        }
      }

      if (quotationNodes.length === 0) {
        return tableNodes;
      }

      tableNodes.push(
        <MantineTable
          key={`table_r_${residuo.idPropostaResiduo?.toString()}`}
          className="custom-mantine-table"
          withTableBorder
          withColumnBorders
          striped
        >
          <MantineTable.Thead>
            <MantineTable.Tr>
              <MantineTable.Th colSpan={2}>Geral</MantineTable.Th>
              <MantineTable.Th colSpan={1}>Plano</MantineTable.Th>
              <MantineTable.Th colSpan={3}>Fornecedor</MantineTable.Th>
              <MantineTable.Th colSpan={1}>Cliente</MantineTable.Th>
            </MantineTable.Tr>
            <MantineTable.Tr>
              <MantineTable.Th>Tipo</MantineTable.Th>
              <MantineTable.Th>Item</MantineTable.Th>
              <MantineTable.Th>Quantidade</MantineTable.Th>
              <MantineTable.Th>Nome</MantineTable.Th>
              <MantineTable.Th>Local</MantineTable.Th>
              <MantineTable.Th>Preço</MantineTable.Th>
              <MantineTable.Th>Preço</MantineTable.Th>
            </MantineTable.Tr>
          </MantineTable.Thead>
          <MantineTable.Tbody>{quotationNodes}</MantineTable.Tbody>
        </MantineTable>
      );

      return tableNodes;
    };

    for (let index = 0; index < proposal.residuos.length; index++) {
      const residuo = proposal.residuos[index];
      const residuoRecorrencia = montarRecorrenciaString(residuo.recorrencia);
      const plano = buildPlan(residuo);

      residueNodes.push(
        <div style={{ pageBreakAfter: index < proposal.residuos.length - 1 ? 'always' : 'avoid' }}>
          {buildSectionHeader('Informações do resíduo.')}
          <Accordion
            key={`accordion_r_${residuo.idPropostaResiduo!.toString()}`}
            chevronSize={0}
            variant="contained"
            defaultValue={residuo.idPropostaResiduo!.toString()}
          >
            <Accordion.Item
              key={`accordion_item_r_${residuo.idPropostaResiduo!.toString()}`}
              value={residuo.idPropostaResiduo!.toString()}
            >
              <Accordion.Control>
                <Group justify="space-between">
                  <Group>
                    <ProfileCardLink
                      id={residuo.idResiduo.toString()}
                      name={residuo.residuoCliente}
                      nameSize="md"
                      description={`Código IBAMA: ${residuo.codigoIBAMA || '-'} | Perigoso: ${
                        residuo.residuoClientePerigoso ? 'Sim' : 'Não'
                      }`}
                      descriptionLength={100}
                      descriptionSize="sm"
                      linkPrefix="residues"
                      showLink={false}
                    />
                    <Group>
                      <Stack gap="xs">
                        {residuo.estimativa && (
                          <Badge
                            key={newGuid()}
                            variant="outline"
                            size="md"
                            color={Feature.Home.Proposal.color}
                          >
                            {`Estimativa: ${residuo.estimativa} ${residuo.estimativaUnidadeMedida1} / ${residuo.estimativaUnidadeMedida2}`}
                          </Badge>
                        )}
                        {residuo.minimoAceitavel ? (
                          <Badge key={newGuid()} variant="outline" size="md" color="orange">
                            {`Mínimo Aceitável: ${residuo.minimoAceitavel} ${residuo.minimoAceitavelUnidadeMedida1} / ${residuo.minimoAceitavelUnidadeMedida2}`}
                          </Badge>
                        ) : (
                          <></>
                        )}
                      </Stack>
                      <Stack gap="xs">
                        {residuo.compra && (
                          <Badge
                            key={newGuid()}
                            variant="outline"
                            size="md"
                            color={Feature.Home.Proposal.color}
                          >
                            Compra
                          </Badge>
                        )}
                        {residuo.cobrarTolerancia && (
                          <Badge
                            key={newGuid()}
                            variant="outline"
                            size="md"
                            color={Feature.Home.Proposal.color}
                          >
                            Cobrar Tolerâncias
                          </Badge>
                        )}
                      </Stack>
                      <Stack gap="xs">
                        {residuoRecorrencia && (
                          <Badge
                            key={newGuid()}
                            variant="outline"
                            size="md"
                            color={Feature.Home.Proposal.color}
                          >
                            <div>
                              <div>
                                Recorrência: {residuoRecorrencia.str1}
                                {residuoRecorrencia.str2 ? ` (${residuoRecorrencia.str2})` : ''}
                              </div>
                            </div>
                          </Badge>
                        )}
                      </Stack>
                    </Group>
                  </Group>
                </Group>
              </Accordion.Control>
              <Accordion.Panel>
                <div key={`r_${residuo.idPropostaResiduo}`}>
                  <Paper shadow="xs" p="md" withBorder>
                    {buildResidueClient(residuo)}
                    <Space h="xs" />
                    <Divider my="sm" variant="dashed" />

                    {buildResidueDocuments(residuo)}

                    {plano.length > 0 && (
                      <>
                        <Space h="xs" />
                        <Divider my="sm" variant="dashed" />

                        <PageSection size="lg" color={Feature.Home.Proposal.color} label="Plano" text="" />
                        <Space h="xs" />
                        {plano}
                      </>
                    )}
                  </Paper>
                </div>
              </Accordion.Panel>
            </Accordion.Item>
          </Accordion>
        </div>
      );

      if (index < proposal.residuos.length - 1) {
        residueNodes.push(<Space key={newGuid()} h="lg" />);
      }
    }

    return residueNodes;
  };

  const buildServices = (): ReactNode[] => {
    const { proposal } = result.data!;

    const serviceNodes: ReactNode[] = [];

    const buildServiceClient = (servico: ProposalServiceType) => {
      const cliente = {
        cnpj: servico.clienteCNPJ,
        razaoSocial: servico.clienteRazaoSocial,
        nomeFantasia: servico.clienteNomeFantasia,
        cpf: servico.clienteCPF,
        nome: servico.clienteNome,
      };
      const endereco = servico;

      return (
        <div>
          <PageSection size="lg" color={Feature.Home.Proposal.color} label="Cliente e Local" text="" />
          <Space h="xs" />
          <MantineTable withTableBorder withColumnBorders striped>
            <MantineTable.Tbody>
              <MantineTable.Tr>
                <MantineTable.Td>Nome Fantasia / Razão Social / Nome</MantineTable.Td>
                <MantineTable.Td>
                  {cliente.nomeFantasia || cliente.razaoSocial || cliente.nome}
                </MantineTable.Td>
                <MantineTable.Td>CNPJ / CPF</MantineTable.Td>
                <MantineTable.Td>
                  <Badge variant="outline">{cliente.cnpj || cliente.cpf}</Badge>
                </MantineTable.Td>
              </MantineTable.Tr>
              <MantineTable.Tr>
                <MantineTable.Td>Endereço</MantineTable.Td>
                <MantineTable.Td>
                  {`${endereco?.logradouro}, ${endereco.numero}${
                    endereco.complemento ? ` - ${endereco.complemento}` : ''
                  }`}
                </MantineTable.Td>
                <MantineTable.Td>Cidade / UF</MantineTable.Td>
                <MantineTable.Td>{`${endereco.cidade} / ${endereco.codigoEstado}`}</MantineTable.Td>
              </MantineTable.Tr>
              <MantineTable.Tr>
                <MantineTable.Td>Bairro</MantineTable.Td>
                <MantineTable.Td>{endereco?.bairro}</MantineTable.Td>
                <MantineTable.Td>CEP</MantineTable.Td>
                <MantineTable.Td>{endereco?.cep}</MantineTable.Td>
              </MantineTable.Tr>
            </MantineTable.Tbody>
          </MantineTable>
        </div>
      );
    };

    const buildPlan = (servico: ProposalServiceType) => {
      const tableNodes: ReactNode[] = [];
      const quotationNodes: ReactNode[] = [];

      for (const cotacao of servico.cotacoes.filter((x) => x.primario)) {
        const customerText = buildCustomerPricingText(cotacao, false);

        quotationNodes.push(
          <MantineTable.Tr key={`sc_${cotacao.idPropostaServicoCotacao}`}>
            <MantineTable.Td>
              {servico.idResiduoAcondicionamento ? (
                <>
                  <Feature.Reference.Packaging.icon size={16} />
                  {servico.gerenciar ? <IconBriefcase size={16} /> : <></>}
                  {servico.compartilhado ? <IconShare size={16} /> : <></>}
                </>
              ) : servico.idResiduoEquipamento ? (
                <Feature.Reference.Equipment.icon size={16} />
              ) : (
                <Feature.Reference.Entity.icon size={16} />
              )}
            </MantineTable.Td>
            <MantineTable.Td>
              {servico.residuoAcondicionamento || servico.residuoEquipamento || 'Fornecedor'}
            </MantineTable.Td>
            <MantineTable.Td>
              {servico.quantidade} {servico.precificacao.quantidadeUnidadeMedida}
            </MantineTable.Td>
            <MantineTable.Td>
              {!(servico.idResiduoAcondicionamento || servico.idResiduoEquipamento)
                ? `${servico.frequencia} ${servico.frequenciaUnidadeMedida1} / ${servico.frequenciaUnidadeMedida2}`
                : '-'}
            </MantineTable.Td>
            <MantineTable.Td>
              {cotacao.fornecedorNomeFantasia || cotacao.fornecedorRazaoSocial || cotacao.fornecedorNome}
            </MantineTable.Td>
            <MantineTable.Td>
              {buildSupplierPrice({
                ...cotacao,
                quantidadeUnidadeMedida: servico.precificacao.quantidadeUnidadeMedida,
                frequenciaUnidadeMedida: servico.frequenciaUnidadeMedida2,
              })}
            </MantineTable.Td>
            <MantineTable.Td>{customerText ? buildPricingItem(false, cotacao, false) : '-'}</MantineTable.Td>
          </MantineTable.Tr>
        );
      }

      if (quotationNodes.length === 0) {
        return tableNodes;
      }

      tableNodes.push(
        <MantineTable
          key={`table_s_${servico.idPropostaServico?.toString()}`}
          className="custom-mantine-table"
          withTableBorder
          withColumnBorders
          striped
        >
          <MantineTable.Thead>
            <MantineTable.Tr>
              <MantineTable.Th colSpan={2}>Geral</MantineTable.Th>
              <MantineTable.Th colSpan={2}>Plano</MantineTable.Th>
              <MantineTable.Th colSpan={2}>Fornecedor</MantineTable.Th>
              <MantineTable.Th colSpan={1}>Cliente</MantineTable.Th>
            </MantineTable.Tr>
            <MantineTable.Tr>
              <MantineTable.Th>Tipo</MantineTable.Th>
              <MantineTable.Th>Item</MantineTable.Th>
              <MantineTable.Th>Quantidade</MantineTable.Th>
              <MantineTable.Th>Frequência</MantineTable.Th>
              <MantineTable.Th>Nome</MantineTable.Th>
              <MantineTable.Th>Preço</MantineTable.Th>
              <MantineTable.Th>Preço</MantineTable.Th>
            </MantineTable.Tr>
          </MantineTable.Thead>
          <MantineTable.Tbody>{quotationNodes}</MantineTable.Tbody>
        </MantineTable>
      );

      return tableNodes;
    };

    for (let index = 0; index < proposal.servicos.length; index++) {
      const servico = proposal.servicos[index];
      const servicoRecorrencia = montarRecorrenciaString(servico.recorrencia);
      const plano = buildPlan(servico);

      serviceNodes.push(
        <div style={{ pageBreakAfter: index < proposal.servicos.length - 1 ? 'always' : 'avoid' }}>
          {buildSectionHeader('Informações do serviço.')}
          <Accordion
            key={`accordion_s_${servico.idPropostaServico!.toString()}`}
            chevronSize={0}
            variant="contained"
            defaultValue={servico.idPropostaServico!.toString()}
          >
            <Accordion.Item
              key={`accordion_s_${servico.idPropostaServico!.toString()}`}
              value={servico.idPropostaServico!.toString()}
            >
              <Accordion.Control>
                <Group>
                  <ProfileCardLink
                    id={servico.idServico.toString()}
                    name={servico.servico}
                    nameSize="md"
                    description={servico.servicoDescricao}
                    descriptionSize="sm"
                    linkPrefix="services"
                    showLink={false}
                  />
                  <div>
                    <Group>
                      <Badge key={newGuid()} variant="outline" size="md" color={Feature.Home.Proposal.color}>
                        {`${servico.residuoAcondicionamento || servico.residuoEquipamento || 'Fornecedor'}`}
                      </Badge>
                      {servicoRecorrencia && (
                        <Badge
                          key={newGuid()}
                          variant="outline"
                          size="md"
                          color={Feature.Home.Proposal.color}
                        >
                          <div>
                            <div>
                              Recorrência: {servicoRecorrencia.str1}
                              {servicoRecorrencia.str2 ? ` (${servicoRecorrencia.str2})` : ''}
                            </div>
                          </div>
                        </Badge>
                      )}
                    </Group>
                  </div>
                </Group>
              </Accordion.Control>
              <Accordion.Panel>
                <div key={`r_${servico.idPropostaServico}`}>
                  <Paper shadow="xs" p="md" withBorder>
                    {buildServiceClient(servico)}

                    {plano.length > 0 && (
                      <>
                        <Space h="xs" />
                        <Divider my="sm" variant="dashed" />

                        <PageSection size="lg" color={Feature.Home.Proposal.color} label="Plano" text="" />
                        <Space h="xs" />
                        {plano}
                      </>
                    )}
                  </Paper>
                </div>
              </Accordion.Panel>
            </Accordion.Item>
          </Accordion>
        </div>
      );

      if (index < proposal.servicos.length - 1) {
        serviceNodes.push(<Space key={newGuid()} h="lg" />);
      }
    }

    return serviceNodes;
  };

  let residueNodes: ReactNode[] = [];
  let serviceNodes: ReactNode[] = [];

  if (result.data !== null) {
    residueNodes = buildResidues();
    serviceNodes = buildServices();
  }

  return result.data === null ? (
    <Center>
      <Loader size="xl" />
    </Center>
  ) : (
    <Card ref={refContent} className="print" style={{ margin: 0, padding: 0 }}>
      <style>{`@media print {.print{zoom: 75%;}}`}</style>
      <div>
        {buildGeneral()}
        <Space h="lg" />

        {buildClient()}
        <Space h="lg" />

        {residueNodes.length > 0 && <>{residueNodes}</>}

        {serviceNodes.length > 0 && (
          <div
            style={{
              pageBreakBefore: residueNodes.length > 0 && serviceNodes.length > 0 ? 'always' : 'avoid',
            }}
          >
            <Space h="lg" />
            {serviceNodes}
          </div>
        )}
      </div>
      <Affix position={{ bottom: 20, left: '50%' }}>
        <Transition transition="slide-up" mounted={scroll.y > 0}>
          {(transitionStyles) => (
            <Button
              leftSection={<IconArrowNarrowUp size={18} />}
              style={transitionStyles}
              color="secondary"
              onClick={() => scrollTo({ y: 0 })}
            >
              Ir ao topo
            </Button>
          )}
        </Transition>
      </Affix>
    </Card>
  );
}

export default ProposalView;
